import * as actionType from '../actionTypes';

const initialState = {
    proposalCount:{},
    selectedProposals:[],
    selectedType:'day',
    ifscData:[],
    totalPages:1,
    historyData: [],
    paymentMethodList: []
}
const dashboardReducer = (state = initialState, action) => {
    // debugger;
    switch (action.type) {
        case actionType.PROPOSAL_COUNT:
            return {
                ...state,
                proposalCount:action.proposalCount
            }; 
        case actionType.SELECTED_PROPOSALS:
          return {
            ...state,
            selectedProposals:action.selectedProposals,
            selectedType:action.selectedType
          }
        case actionType.CHANGE_SELECTION:
            return {
                ...state,
                selectedType:action.selectedType
            }; 
        case actionType.IFSC_DATA:
            return{
                ...state,
                ifscData:action.ifscData.itemList,
                totalPages:action.ifscData.totalPages
            }
            case actionType.FINCARE_HISTORY:
                return {
                    ...state,
                    historyData: action.payload
                }
            case actionType.PAYMENT_METHOD_LIST:
            return {
                ...state,
                paymentMethodList: action.payload
            }
        default:
            return state
    }
}
export default dashboardReducer;
